module.exports = __webpack_public_path__ + "img/winners2.0538eb48.svg";